import { Button } from "@/components/ui/button";
import type {
  ActionLabelContext,
  ActionPresentation,
  ResolvedObjectAction,
} from "@/object-actions/types";
import { getActionIcon, getActionLabel } from "@/object-actions/utils";

export interface ObjectActionLabeledButtonProps {
  action: ResolvedObjectAction;
  labelCtx: ActionLabelContext;
  presentation: Extract<
    ActionPresentation,
    "primary-button" | "secondary-button"
  >;
}

/**
 * Pane-header action control: shadcn `Button` with icon + visible label
 * (`primary-button` / `secondary-button` presentations).
 */
export function ObjectActionLabeledButton({
  action,
  labelCtx,
  presentation,
}: ObjectActionLabeledButtonProps) {
  const Icon = getActionIcon(action.definition, labelCtx);
  const label = getActionLabel(action.definition, labelCtx);
  const variant = presentation === "primary-button" ? "primary" : "ghost";

  return (
    <Button
      type="button"
      variant={variant}
      size="sm"
      className="h-7 shrink-0 px-2.5 text-xs font-medium"
      disabled={action.disabled}
      onClick={() => window.setTimeout(() => action.handler(), 0)}
    >
      <Icon />
      {label}
    </Button>
  );
}
